/**
 * External Imports
 */
import { FC } from 'react';
import { connect, useDispatch } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';
import { useAnalyticsApi } from '@shared-web-analytics/react/dist';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';
import { clearRoundState } from '../../../../redux/actions';
import { logRoundClick } from '../../../../utils/analyticsHelpers';
import supportRoundingTypes from '../../../../constants/supportRoundingTypes.json';

interface CancelRoundBtnProps {
  isEdit: boolean;
  type: string;
}

const CancelRoundBtn: FC<CancelRoundBtnProps> = ({ isEdit, type }) => {
  const dispatch = useDispatch();

  const { logTrackingEvent } = useAnalyticsApi();

  const handleCancelRound = () => {
    logTrackingEvent(logRoundClick('cancel', type));
    dispatch(clearRoundState());
  };

  return (
    <NeuButton
      data-testid="cancel-round-button"
      className={`mx-2${isEdit ? ' invisible' : ''}`}
      color="red"
      kind="primary"
      size="small"
      onClick={handleCancelRound}
    >
      Cancel{' '}
      {supportRoundingTypes.validation.includes(type) ? 'Validation' : 'Round'}
    </NeuButton>
  );
};

const mapReduxStateToProps = (state: RootState) => ({
  authorizedUser: state.AuthorizedUser.authorizedUser
});

export default connect(mapReduxStateToProps)(CancelRoundBtn);
